import { useMemo } from 'react';

import { useAppSelector } from '@/redux/hooks';
import { getBidderId } from '@/redux/modules/account/user/user.selectors';
import { getDeployment } from '@/redux/modules/config';
import {
    AppDownloadSource,
    type AppDownloadSourceValue,
    AppDownloadTriggerValue,
    buildAppDownloadRedirectUrl,
} from '@/utils/urls/appDownloadRedirectUrl';

type UseAppDownloadRedirectUrlArgs = {
    source?: AppDownloadSourceValue;
    trigger: AppDownloadTriggerValue;
};

/**
 * Builds the analytics-service app-download redirect URL for the current deployment and bidder.
 */
export const useAppDownloadRedirectUrl = ({
    source = AppDownloadSource.LeadingBidder,
    trigger,
}: UseAppDownloadRedirectUrlArgs): string => {
    const deployment = useAppSelector(getDeployment);
    const bidderId = useAppSelector(getBidderId);

    return useMemo(
        () =>
            buildAppDownloadRedirectUrl({
                bidderId,
                deployment,
                source,
                trigger,
            }),
        [bidderId, deployment, source, trigger]
    );
};
